import { HorseRaceModel } from './HorseRaceModel';
import { HorseModel } from './HorseModel';
export class HorseNoteModel {
   id: number;
   raceCard: HorseRaceModel;
   horse: HorseModel;
   option: Array<number>;
   note: string;


	constructor(id: number, raceCard: HorseRaceModel, horse: HorseModel, option: Array<number>, note: string) {
    this.id = id;
    this.raceCard = raceCard;
    this.horse = horse;
    this.option = option;
    this.note = note;
	}

}



// WEBPACK FOOTER //
// ./src/model/horse/HorseNoteModel.ts